function POVAndTenseBlockEditor() {
  return <div>Add variables: pov_value, tense_value, and pov_characters</div>;
}

export default POVAndTenseBlockEditor;
